import { useRef, useEffect } from 'react';
import { ImageHotspotsComponent } from '@apps/image-hotspots';
import { useComponentFrameworkAutoDeactivation } from '@provider/component-framework';
import { useLocation } from '@provider/navigation';
import { contentTransitionDurationMs } from './comp.router.style.js';
import { jsx } from 'react/jsx-runtime';

function EmbedContent(props) {
  const isTransitioningBetweenPagesRef = useTransitionState();
  useComponentFrameworkAutoDeactivation(props.rootRef, {
    componentId: props.node.component.envelope.ID,
    isDisabledRef: isTransitioningBetweenPagesRef,
    onDeactivate: props.onDeactivate
  });
  return /*#__PURE__*/jsx(ImageHotspotsComponent, {
    context: "embedded",
    onCollapse: props.onCollapse,
    onActivate: props.onActivate,
    component: props.node.component,
    node: props.node
  });
}
function useTransitionState() {
  const location = useLocation();
  const isTransitioningRef = useRef(false);
  useEffect(() => {
    isTransitioningRef.current = true;
    const timeoutId = setTimeout(() => {
      isTransitioningRef.current = false;
    }, contentTransitionDurationMs);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.asPath]);
  return isTransitioningRef;
}

export { EmbedContent };
//# sourceMappingURL=comp.embed-integration.js.map
